import { ReactNode } from 'react';
import { useLocation } from 'wouter';
import { cn } from '@/lib/utils';

interface SchedulingLayoutProps {
  children: ReactNode;
}

const SCHEDULING_NAV_ITEMS = [
  { href: '/scheduling/appointments', label: '预约列表' },
  { href: '/scheduling/appointments/create', label: '新建预约' },
  { href: '/scheduling/staff-schedules', label: '员工排班' },
];

export default function SchedulingLayout({ children }: SchedulingLayoutProps) {
  const [location] = useLocation();

  return (
    <div className="flex flex-col gap-6">
      <div className="border-b border-border">
        <nav className="flex gap-8 px-6 py-3">
          {SCHEDULING_NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={cn(
                'text-sm font-medium transition-colors',
                location.startsWith(item.href)
                  ? 'border-b-2 border-primary text-primary pb-3'
                  : 'text-muted-foreground hover:text-foreground pb-3',
              )}
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>
      <div className="px-6">{children}</div>
    </div>
  );
}
